import { connect } from 'react-redux';
import ADUH_LOGO from "_Mobile/assets/aduh/ADUH.png";
import COMING_SOON from "_Mobile/assets/aduh/aduh_coming_soon.png";
import { Link } from 'react-router-dom';
import MobileHomeProductWidget from '_Mobile/scenes/MobileHome2021winter/MobileHomeProductWidget';
import "./style.css";

const MobileAduhLanding = (props) => {
  const { fetchAduhCollectionReducer, collectionProps } = props;
  const { collection = {} } = fetchAduhCollectionReducer;
  const { products = [] } = collectionProps || collection;
  return (
    <div className="Aduh MobileAduhLanding">
      <div className="header">
        <Link to="/aduh">
          <img className="logo" src={ADUH_LOGO} alt="" />
        </Link>
        <div className="subtitle">Toko</div>
      </div>
      <div className="FeatureItems">
        {products.length > 0 ? (
          products.map((p, index) => (
            <MobileHomeProductWidget p={p} key={index} fromAduh />
          ))
        ) : (
          <img className="comingSoon" src={COMING_SOON} alt="" />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  ...state
})

export default connect(mapStateToProps, {})(MobileAduhLanding);